import * as fromDatatype from "../datatype-library/index";

export interface bl_crm_risk_spending_limit_rules_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  spend_limit_default: fromDatatype.NumericDatatypeInterface;
  spend_limit_new_member: fromDatatype.NumericDatatypeInterface;
  spend_limit_period: fromDatatype.IntegerDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ban_period: fromDatatype.IntegerDatatypeInterface;
  name: fromDatatype.VrsnDataFieldInterface;
  code: fromDatatype.VrsnDataFieldInterface;
  memberclass_guid: fromDatatype.GuidDataFieldInterface;
  admin_contact: fromDatatype.JsonDatatypeInterface;
}

export class bl_crm_risk_spending_limit_rules_hdr_RowClass
  implements bl_crm_risk_spending_limit_rules_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  login_guid: fromDatatype.GuidDataFieldInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  spend_limit_default: fromDatatype.NumericDatatypeInterface;
  spend_limit_new_member: fromDatatype.NumericDatatypeInterface;
  spend_limit_period: fromDatatype.IntegerDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ban_period: fromDatatype.IntegerDatatypeInterface;
  name: fromDatatype.VrsnDataFieldInterface;
  code: fromDatatype.VrsnDataFieldInterface;
  memberclass_guid: fromDatatype.GuidDataFieldInterface;
  admin_contact: fromDatatype.JsonDatatypeInterface;
}
